import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { api } from "../../../_services/api.service";
import Loader from "react-loaders";
import { Row, Col, CustomInput, Card, CardBody } from "reactstrap";
import ReactApexChart from "react-apexcharts";

const ObjectiveAverageBarChart = ({ partnerScenarioId, partnerScenario }) => {
  const objTypes = [
    {
      name: "All",
      value: 3,
    },
    {
      name: "Custom",
      value: 1,
    },
    {
      name: "Suggested",
      value: 2,
    },
  ];
  const consistencyRateTypes = [
    { value: 0, name: "All" },
    { value: 1, name: "Very Highly Consistent (CR < .1)" },
    { value: 2, name: "Highly Consistent (CR < .2)" },
    { value: 3, name: "Mostly Consistent (CR < .3)" },
  ];
  let [chartHeight, setChartHeight] = useState(300);
  let [selectedObjType, setSelectedObjType] = useState(3);
  let [isLoading, setIsLoading] = useState(true);
  let [partnerScenarioChartData, setPartnerScenarioChartData] = useState([]);
  let [consistencyRate, setConsistencyRate] = useState(0);

  const [barChartOptionsSeries, setBarChartOptionsSeries] = useState(null);

  useEffect(() => {
    if (partnerScenarioId > 0) {
      load();
    } else {
      setIsLoading(false);
    }
  }, [selectedObjType, consistencyRate]);

  const load = () => {
    setIsLoading(true);
    api
      .getPartnerChart(partnerScenarioId, selectedObjType, consistencyRate)
      .then((data) => {
        setIsLoading(false);
        setPartnerScenarioChartData(data);
        populateBarChart(data);
      });
  };

  const populateBarChart = (list) => {
    let options = {
      chart: {
        type: "bar",
        height: 350,
        // stacked: false,
        toolbar: {
          show: true,
        },
        zoom: {
          enabled: true,
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0,
            },
          },
        },
      ],
      plotOptions: {
        bar: {
          horizontal: true,
        },
      },
      xaxis: {
        type: "string",
        categories: [],
        labels: {
          formatter: function (val) {
            return `${parseInt(val)}%`;
          },
        },
      },
      legend: {
        position: "right",
        offsetY: 40,
      },
      fill: {
        opacity: 1,
      },
      dataLabels: {
        enabled: true,
        formatter: function (val, opt) {
          return isNaN(parseInt(val)) ? "" : parseInt(val) + "%";
        },
        offsetX: 0,
      },
      tooltip:{
        y:{
          formatter: function(val) {
            return isNaN(parseInt(val)) ? "" : parseInt(val) + "%";
          }
        }
      }
    };
    let series = [];

    let height = 20;

    list.forEach((x) => {
      options.xaxis.categories.push(x.objectiveName);
      series.push(x.objectiveScore);
      height += 50;
    });

    setChartHeight(height);
    // series.push(data);

    setBarChartOptionsSeries({ options, series: [{ data: series }] });
    console.log({ options, series });
  };

  return (
    <>
      <Card className="main-card mb-3">
        <CardBody>
          {isLoading && <Loader style={{}} type="ball-pulse" active />}
          {barChartOptionsSeries != null && (
            <ReactApexChart
              options={barChartOptionsSeries.options}
              series={barChartOptionsSeries.series}
              type="bar"
              height={`${chartHeight}px`}
            />
          )}
          <Row>
            <Col md="6">
              <div className="form-group">
                <span>Type</span>
                <CustomInput
                  type="select"
                  id="selectedObjTypeid"
                  value={selectedObjType}
                  name="selectedObjTypeidd"
                  onChange={(e) => {
                    setSelectedObjType(e.target.value);
                  }}
                >
                  {objTypes.map((x) => {
                    return (
                      <option key={"ii" + x.value} value={x.value}>
                        {x.name}
                      </option>
                    );
                  })}
                </CustomInput>
              </div>
            </Col>
            <Col md="6">
              <div className="form-group">
                <span>Consistency Rate</span>
                <CustomInput
                  type="select"
                  id="visibleRowsId"
                  value={consistencyRate}
                  name="visibleRowsId"
                  onChange={(e) => {
                    setConsistencyRate(e.target.value);
                  }}
                >
                  {consistencyRateTypes.map((x) => {
                    return (
                      <option key={"ii" + x.value} value={x.value}>
                        {x.name}
                      </option>
                    );
                  })}
                </CustomInput>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
};

export default ObjectiveAverageBarChart;
